import { render, staticRenderFns } from "./SiteCard.vue?vue&type=template&id=2cb3e594&"
import script from "./SiteCard.vue?vue&type=script&lang=js&"
export * from "./SiteCard.vue?vue&type=script&lang=js&"
import style0 from "./SiteCard.vue?vue&type=style&index=0&id=2cb3e594&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports